/** Neutral basemap shared by web, search previews and the hosted native frame. */
export function mapStyles(theme: 'light' | 'dark'): google.maps.MapTypeStyle[] {
  const dark = theme === 'dark';
  return [
    { elementType: 'geometry', stylers: [{ color: dark ? '#242424' : '#f1f1ef' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: dark ? '#bdbdbd' : '#595959' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: dark ? '#242424' : '#f1f1ef' }] },
    { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: dark ? '#242424' : '#f1f1ef' }] },
    { featureType: 'poi', elementType: 'geometry', stylers: [{ color: dark ? '#292929' : '#e7e7e4' }] },
    { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] },
    { featureType: 'transit', elementType: 'labels', stylers: [{ visibility: 'off' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: dark ? '#3a3a3a' : '#ffffff' }] },
    { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: dark ? '#292929' : '#dededb' }] },
    { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: dark ? '#4a4a4a' : '#d4d4d0' }] },
    { featureType: 'water', elementType: 'geometry', stylers: [{ color: dark ? '#17242e' : '#d8e0e6' }] },
  ];
}
